var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-menu",
    {
      attrs: {
        "position-x": _vm.position.x,
        "position-y": _vm.position.y,
        "close-on-content-click": false,
        "nudge-width": 300,
        "offset-x": "",
      },
      model: {
        value: _vm.menu,
        callback: function ($$v) {
          _vm.menu = $$v
        },
        expression: "menu",
      },
    },
    [
      _c(
        "v-form",
        { ref: "form", staticStyle: { width: "100%" } },
        [
          _c(
            "v-card",
            [
              _c(
                "v-card-title",
                { staticClass: "title py-1" },
                [
                  _vm._v(
                    "\n        " + _vm._s(_vm.type) + " guideline\n        "
                  ),
                  _c("v-spacer"),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      staticClass: "ma-0",
                      attrs: { icon: "" },
                      on: {
                        click: function ($event) {
                          return _vm.close()
                        },
                      },
                    },
                    [_c("v-icon", [_vm._v("close")])],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c("v-divider"),
              _vm._v(" "),
              _c(
                "v-card-text",
                [
                  _c("v-select", {
                    attrs: {
                      rules: [_vm.rules.required],
                      "error-messages": _vm.errorMessages.guidelineStations,
                      label: "Guideline",
                      "item-value": "Id",
                      "item-text": "GuidelineName",
                      items: _vm.unusedGuidelines,
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "item",
                        fn: function ({ item }) {
                          return [
                            _c(
                              "div",
                              [
                                _c("v-list-tile-title", [
                                  _vm._v(
                                    "\n                " +
                                      _vm._s(item.GuidelineName) +
                                      "\n              "
                                  ),
                                ]),
                                _vm._v(" "),
                                _c("v-list-tile-sub-title", [
                                  _vm._v(
                                    "\n                " +
                                      _vm._s(item.GuidelineLongName) +
                                      "\n              "
                                  ),
                                ]),
                              ],
                              1
                            ),
                          ]
                        },
                      },
                    ]),
                    model: {
                      value: _vm.formObject.guidelineId,
                      callback: function ($$v) {
                        _vm.$set(_vm.formObject, "guidelineId", $$v)
                      },
                      expression: "formObject.guidelineId",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-card-actions",
                [
                  _c("v-spacer"),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      attrs: { color: "success", outline: "" },
                      on: {
                        click: function ($event) {
                          return _vm.submit()
                        },
                      },
                    },
                    [_vm._v(_vm._s(_vm.$t("Button.Save")))]
                  ),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      attrs: { outline: "", color: "secondary" },
                      on: {
                        click: function ($event) {
                          return _vm.close()
                        },
                      },
                    },
                    [_vm._v(_vm._s(_vm.$t("Button.Cancel")))]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }